<div class="wrapper">
  <!-- The drawings detail header (Figma 33128:76594): ‹ back to the sheet, what is compared, which revisions -->
  @if (!embedded) {
    <app-drawings-page-header [title]="compareTitle" [subtitle]="older && newer ? revisionName(older) + ' → ' + revisionName(newer) : ''"
      [backLabel]="backLabelOverride || 'Back to ' + (newer?.sheet?.number ? newer.sheet.number + ' ' + revisionName(newer) : 'the sheet')" backTestId="drawing-compare-back"
      titleTestId="drawing-compare-title" (back)="back.emit()" />
  }

  @if (older && newer) {
    @if (similarityNote) {
      <!-- Wrong-drawing guard: DESIGN.md alert_banner, inline warning (Figma 10936:38684) -->
      <div class="similarity-note" role="status" data-testid="drawing-compare-similarity-note">
        <mat-icon class="similarity-note-icon">warning_amber</mat-icon>
        <span>{{ similarityNote }}</span>
      </div>
    }

    <div class="stage-bar">
      <!-- W67: the register's Grid / List control; Overlay, the default, first (Sri) -->
      <div class="view-toggle" role="group" aria-label="Compare view">
        <button type="button" [class.active]="mode === 'overlay'" [attr.aria-pressed]="mode === 'overlay'" data-testid="drawing-compare-mode-overlay" (click)="setMode('overlay')">Overlay</button>
        <button type="button" [class.active]="mode === 'side'" [attr.aria-pressed]="mode === 'side'" data-testid="drawing-compare-mode-side" (click)="setMode('side')">Side by side</button>
      </div>
      @if (mode === 'side') {
        <div class="stage-tools">
          <button type="button" class="icon-button" aria-label="Zoom out" data-testid="drawing-compare-zoom-out" [disabled]="!canZoomOut" (click)="zoomBy(-1)"><mat-icon>remove</mat-icon></button>
          <span class="zoom-text mat-caption" data-testid="drawing-compare-zoom">{{ transform.scale | number: '1.0-1' }}×</span>
          <button type="button" class="icon-button" aria-label="Zoom in" data-testid="drawing-compare-zoom-in" [disabled]="!canZoomIn" (click)="zoomBy(1)"><mat-icon>add</mat-icon></button>
          <button type="button" class="link-button mat-body-1" data-testid="drawing-compare-fit" (click)="resetView()">Fit</button>
        </div>
      }
    </div>

    @if (mode === 'side') {
      <div class="compare-side">
        @for (rev of [older, newer]; track rev.uuid; let first = $first) {
          <section class="compare-column">
            <span class="compare-label" data-testid="drawing-compare-label">{{ revisionName(rev) }}</span>
            <div #firstPane class="compare-pane" tabindex="0" [attr.aria-label]="revisionName(rev) + '. Drag to pan, scroll to zoom.'"
              (wheel)="onWheel($event)" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
              (pointerup)="onPointerUp()" (pointercancel)="onPointerUp()" (keydown)="onKey($event)">
              <div class="compare-page" data-testid="drawing-compare-page" [style.transform]="transformCss">
                @if (rev.preview_url) {
                  <img class="compare-image" [src]="rev.preview_url" [alt]="(rev.sheet?.number ?? '') + ' ' + revisionName(rev)" draggable="false" />
                } @else {
                  <div class="empty-state mat-body-1">This page has no preview yet.</div>
                }
              </div>
            </div>
          </section>
        }
      </div>
    } @else {
      <!-- W67: both revisions on one canvas, removed red, added blue, unchanged grey -->
      <app-drawing-compare-overlay [older]="older" [newer]="newer" />
    }
  }
</div>
